module.exports = __webpack_public_path__ + "img/ic-success-application.ea50e9df.svg";